import {
  FormattedShopifyCollection,
  FormattedShopifyProduct
} from '@portal/types/shopify/product.formatted.types';

export const getShopifyCustomMetafield = (
  object: FormattedShopifyCollection | FormattedShopifyProduct,
  key: string
) => {
  return object.metafields.find(
    (metafield) => metafield && metafield.namespace === 'custom' && metafield.key === key
  );
};
